import React from "react";
import {useNavigate} from "react-router-dom";
import {PlusCircle, Timer, FileEdit, LucideBrainCog} from "lucide-react";

export default function QuickStartActions() {
    const navigate = useNavigate();

    const actions = [
        {
            label: "New Task",
            icon: <PlusCircle size={20}/>,
            bg: "bg-[#2A2B32]",
            hover: "hover:bg-[#33343E]",
            onClick: () => navigate("/task", {state: {openAddTaskModal: true}}),
        },
        {
            label: "Start Focus",
            icon: <Timer size={20}/>,
            bg: "bg-[#2A2B32]",
            hover: "hover:bg-[#33343E]",
            onClick: () => navigate("/session"),
        },
        {
            label: "New Note",
            icon: <FileEdit size={20}/>,
            bg: "bg-[#2A2B32]",
            hover: "hover:bg-[#33343E]",
            onClick: () => navigate("/note/new"),
        },
        {
            label: "Review",
            icon: <LucideBrainCog size={20} />,
            bg: "bg-[#2A2B32]",
            hover: "hover:bg-[#33343E]",
            onClick: () => navigate("/recall/review"),
        },
    ];

    return (
        <div className="bg-[#1E1F25] p-6 rounded-xl shadow-lg border border-[#2A2B32]">
            <h2 className="text-xl font-semibold text-gray-200 mb-4">
                Quick Start
            </h2>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {actions.map((action) => (
                    <button
                        key={action.label}
                        onClick={action.onClick}
                        className={`
              ${action.bg} ${action.hover}
              flex flex-col items-center justify-center gap-2
              p-4 rounded-xl shadow-md transition-all
              text-gray-200
              hover:shadow-[0_0_12px_rgba(255,255,255,0.08)]
              active:scale-95
            `}
                    >
                        {action.icon}
                        <span className="text-sm font-medium">{action.label}</span>
                    </button>
                ))}
            </div>
        </div>
    );
}
